import initialState from './initialState';
import { SET_CHART_DATA_TYPE } from '../actions/actionTypes';

export default function chartDataType(state = initialState.chartDataType, action) {
  switch (action.type) {
    case SET_CHART_DATA_TYPE:
      return action.setToVal;
    default:
      return state;
  }
}
